class PhoneNumberInput {
  static intlTelInputPromise = null

  constructor(container) {
    this.container = container
    this.iti = null
    this.input = container.querySelector('[data-phone-input]')
    this.countryCodeInput = container.querySelector('[data-phone-country-code]')
    this.countryNameInput = container.querySelector('[data-phone-country-name]')
    this.form = container.closest('form')

    if (
      !(this.input instanceof HTMLInputElement)
      || !(this.countryCodeInput instanceof HTMLInputElement)
      || !(this.countryNameInput instanceof HTMLInputElement)
    ) {
      return
    }

    this.initPhoneInput()
  }

  async initPhoneInput() {
    await this.loadIntlTelInput()

    if (!window.intlTelInput) return

    this.iti = window.intlTelInput(this.input, {
      initialCountry: 'gb',
      preferredCountries: ['gb', 'us', 'de', 'fr', 'es'],
      separateDialCode: true,
      allowDropdown: true,
    })

    this.updateCountryFields()
    this.detectUserCountry()

    this.input.addEventListener('countrychange', () => {
      this.updateCountryFields()
    })

    this.handleFormSubmit()
  }

  async loadIntlTelInput() {
    if (!PhoneNumberInput.intlTelInputPromise) {
      PhoneNumberInput.intlTelInputPromise = new Promise((resolve) => {
        const existingScript = document.querySelector('script[data-intl-tel-input]')

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true })
          return
        }

        const script = document.createElement('script')
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js'
        script.dataset.intlTelInput = 'true'
        script.onload = resolve
        document.head.appendChild(script)

        if (!document.querySelector('link[data-intl-tel-input]')) {
          const link = document.createElement('link')
          link.rel = 'stylesheet'
          link.href = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.min.css'
          link.dataset.intlTelInput = 'true'
          document.head.appendChild(link)
        }
      })
    }

    return PhoneNumberInput.intlTelInputPromise
  }

  updateCountryFields() {
    if (!this.iti) return

    const countryData = this.iti.getSelectedCountryData()
    this.countryCodeInput.value = countryData.dialCode ? `+${countryData.dialCode}` : ''
    this.countryNameInput.value = countryData.name || ''
  }

  async detectUserCountry() {
    try {
      const response = await fetch('https://ipapi.co/json/')
      const data = await response.json()

      if (data && data.country_code && this.iti) {
        this.iti.setCountry(data.country_code.toLowerCase())
        this.updateCountryFields()
      }
    }
    catch (error) {
      console.error('Error detecting user location:', error)
    }
  }

  handleFormSubmit() {
    if (!this.form || !this.iti) return

    this.form.addEventListener('submit', () => {
      const countryData = this.iti.getSelectedCountryData()

      if (countryData.dialCode) {
        this.input.value = `+${countryData.dialCode} ${this.input.value.trim()}`
      }

      this.updateCountryFields()
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-phone-field]').forEach((container) => {
    new PhoneNumberInput(container)
  })
})
